import React from 'react'
import SkillBoxAllProducts from '../feature/SkilltoSkillBox/skillBoxAllProducts'

function SkilltoSkillBox() {
  return (
    <SkillBoxAllProducts />
  )
}

export default SkilltoSkillBox;